import React from 'react';
import * as S from './PermissionLabel.styles';
import { Poppins } from './Poppins';

interface PermissionLabelProps {
  label: string;
}

export const PermissionLabel: React.FC<PermissionLabelProps> = ({ label }) => {
  return (
    <S.Div>
      <Poppins px={14} weight={600}>
        {label}
      </Poppins>
    </S.Div>
  );
};
